/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForBillingResourceGraphDBSync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForBillingResourceGraphDBSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForBillingResourceGraphDBSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForBillingResourceGraphDBSync>): BackgroundJobPayloadForBillingResourceGraphDBSync {
        let obj = Object.assign(new BackgroundJobPayloadForBillingResourceGraphDBSync(), model);
        BackgroundJobPayloadForBillingResourceGraphDBSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForBillingResourceGraphDBSync>): BackgroundJobPayloadForBillingResourceGraphDBSync {
        if (!model) return null;
        return BackgroundJobPayloadForBillingResourceGraphDBSync.newInstance(<BackgroundJobPayloadForBillingResourceGraphDBSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForBillingResourceGraphDBSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForBillingResourceGraphDBSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForBillingResourceGraphDBSync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForBillingResourceGraphDBSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account whose Billing-resource data is synced to GraphDB
     */
    service_account_id: string;

}
